"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _validate = _interopRequireDefault(require("../validate"));

function onAppend() {
  var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (action) {
    return action.payload;
  };
  return (0, _validate["default"])({
    name: 'onAppend',
    realTarget: function realTarget(action) {
      return action.target;
    },
    "do": function _do(action, state) {
      return [].concat((0, _toConsumableArray2["default"])(state[action.target]), [selector(action)]);
    }
  });
}

var _default = onAppend;
exports["default"] = _default;